import { useGetUserAppTargetSetting } from "hooks/useGetUserAppTargetSetting";
import { EAppSettings, EBenefitTab } from "library/types";

export function useIsListView() {
  const benefitViewModeAppSettings = useGetUserAppTargetSetting({
    targetSettingName: EAppSettings.benefitViewMode,
  });

  const isListView =
    benefitViewModeAppSettings?.userAppSettingValue === EBenefitTab.list;

  return isListView;
}
